// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Private Endpoint Service API
 * private-endpoint-service-api manages Private Endpoint Services in ingress clusters
 *
 * The version of the OpenAPI document: 1.0
 * Contact: team-aura-networking@neotechnology.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface CustomerEndpoint
 */
export interface CustomerEndpoint {
  /**
   * Human-readable name set by the customer when submitting the endpoint.
   * @type {string}
   * @memberof CustomerEndpoint
   */
  displayName?: string;
  /**
   * Provider endpoint connection state as reported by the operator.
   * @type {string}
   * @memberof CustomerEndpoint
   */
  state?: string;
}

/**
 * Check if a given object implements the CustomerEndpoint interface.
 */
export function instanceOfCustomerEndpoint(
  value: object,
): value is CustomerEndpoint {
  return true;
}

export function CustomerEndpointFromJSON(json: any): CustomerEndpoint {
  return CustomerEndpointFromJSONTyped(json, false);
}

export function CustomerEndpointFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CustomerEndpoint {
  if (json == null) {
    return json;
  }
  return {
    displayName:
      json['display_name'] == null ? undefined : json['display_name'],
    state: json['state'] == null ? undefined : json['state'],
  };
}

export function CustomerEndpointToJSON(json: any): CustomerEndpoint {
  return CustomerEndpointToJSONTyped(json, false);
}

export function CustomerEndpointToJSONTyped(
  value?: CustomerEndpoint | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    display_name: value['displayName'],
    state: value['state'],
  };
}
